angular.module('tax')
    .directive('taxPicker', function (Tax) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {},
            template: `
                <div>
                    <input ng-model="text" class="form-control input-sm text-input unit-input" ng-show="textOnly" title="j.m."/>
                    <select class="form-control input-sm vat-rate-selector" ng-model="text" ng-change="onChange(text)" ng-show="!textOnly" title="Stawka VAT" required="required"
                            ng-options="u as u.label for u in taxRates "></select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                Tax.query().$promise.then(items => {
                    scope.taxRates = []
                    items.forEach(tax => scope.taxRates.push({value: tax.value, label: tax.name}))
                    ngModelCtrl.$render()
                })

                ngModelCtrl.$render = () => {
                    scope.text = ngModelCtrl.$viewValue;

                    if (scope.text && scope.taxRates) {
                        let elemExists = scope.taxRates
                            .find(it => it.value === scope.text.value && it.label === scope.text.label);

                        if (elemExists) {
                            scope.text = elemExists
                        } else {
                            let customTax = {value: scope.text.value, label: scope.text.label}
                            scope.taxRates.push(customTax)
                            scope.text = customTax
                        }
                    }
                }
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => viewValue)

                scope.$watch('text', () => {
                    ngModelCtrl.$setViewValue(scope.text)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                })
            }
        }
    })
